import React from 'react';
import { Content } from './shared';

const CignaGymMembership = () => (
  <Content>
    Did you know working out is considered preventative care? Enjoy discounts at participating gyms.
    <ol>
      <li>Log into your Cigna account.</li>

      <li>
        Go to Wellness {'>'} Healthy Rewards-Discount Programs {'>'} Exercise & Physical Fitness.
      </li>

      <li>Go to Fitness Discounts {'>'} Low Cost Fitness Center Membership.</li>

      <li>Search by location and find your gym!</li>

      <li>Last, click Enroll to register and pay your membership.</li>
    </ol>
  </Content>
);

export default CignaGymMembership;
